export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/environments/environment.ts